var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 68,
    viewBox: "0 0 52 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5788 23.5788H41.729V16.0878C41.729 7.63444 34.992 0.608665 26.5386 0.48034C17.9729 0.368056 10.9311 7.3457 10.9311 15.8793V23.5788H7.08139C3.55246 23.5788 0.665161 26.4661 0.665161 29.995V60.7929C0.665161 64.3218 3.55246 67.2091 7.08139 67.2091H45.5788C49.1077 67.2091 51.995 64.3218 51.995 60.7929V29.995C51.995 26.4661 49.1077 23.5788 45.5788 23.5788ZM28.5758 43.5974V54.6333C28.5758 55.8364 27.6454 56.879 26.4424 56.9431C25.1591 57.0073 24.0844 55.9807 24.0844 54.6975V43.5974C22.2397 42.6991 21.0206 40.7422 21.2131 38.5125C21.4377 36.0262 23.4749 34.0372 25.9611 33.8608C28.9607 33.6522 31.4631 36.0262 31.4631 38.9777C31.4631 41.0149 30.2921 42.7633 28.5758 43.5974ZM37.2377 23.5788H15.4225V15.8793C15.4225 12.9759 16.5614 10.249 18.6306 8.17981C20.6998 6.11058 23.4267 4.9717 26.3301 4.9717C29.2334 4.9717 31.9603 6.11058 34.0295 8.17981C36.0988 10.249 37.2377 12.9759 37.2377 15.8793V23.5788Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.613d4b6c8a4265374c03407ddef5f03e.svg";
export { ForwardRef as ReactComponent };